import $ from 'jquery';
import assign from 'lodash/assign';
import 'select2';

import './TestSelect.scss';
import template from './TestSelect.vhtml';

export default {
	name: 'TestSelect',
	template: template,
	props: {
		options: {},
		value: {},
		placeholder: {
			type: String,
			default: '',
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		theme: {
			type: String,
			default: 'test',
		},
	},
	mounted() {
		const vm = this;
		const $el = $( this.$el );

		// init select2
		$el.select2( vm.settings );

		// Set initial value
		this.updateSelect( vm.value );

		// emit event on change.
		$el.on( 'change', function () {
			vm.$emit( 'input', $el.val() );
		});
	},
	computed: {
		settings() {
			return assign( {}, { data: this.options }, this.defaults );
		},
		defaults() {
			return {
				width: '100%',
				minimumResultsForSearch: Infinity,
				theme: this.theme,
				placeholder: this.placeholder,
				multiple: !!this.multiple,
				templateSelection: option => {
					if ( this.placeholder ) {
						return $( `<span class="select2-test__placeholder">${ this.placeholder }</span><span class="select2-test__value">${ option.text }</span>` );
					} else {
						return option.text;
					}
				},
			};
		},
	},
	watch: {
		value(value) {
			// Simple change detection here
			if ( JSON.stringify( this.value ) !== JSON.stringify( value ) ) {
				this.updateSelect( value );
			}
		},
	},
	methods: {
		updateSelect() {
			$( this.$el )
				// change the value
				.val( this.value )
				// Trigger change event
				.trigger( 'change' );
		},
	},
	destroyed: function () {
		$( this.$el ).off().select2( 'destroy' );
	}
};
